// extracted by mini-css-extract-plugin
export default {"favActive":"Report2Picker_favActive__6IyNg","description":"Report2Picker_description__6PvK7"};